<template>
    <div class="grid-container" :style="gridStyle">
        <div class="grid-cell" :style="gridCellStyle(item)" v-for="item in tpl.children" :key="item.id">
            <renderer :tpl="item" />
        </div>
    </div>
</template>
<script>
const {
    rem: { parseStyle }
} = require('@futuweb/fego-bridge');
const {
    renderer
} = require('@futuweb/fego-render');

export default {
    props: ['tpl'],
    components: {
        renderer
    },
    computed: {
        gridStyle() {
            const styleObj = this.tpl?.style || {};
            const { gridTemplateColumns, gridTemplateRows } = this.tpl.props;
            styleObj.gridTemplateColumns = gridTemplateColumns?.map((x) => x.replace('px', ''))?.join?.(' ') || '100%';
            styleObj.gridTemplateRows = gridTemplateRows?.map((x) => x.replace('px', ''))?.join(' ') || '100%';
            // eslint-disable-next-line max-len
            styleObj.gridTemplateAreas = this.tpl.props.gridTemplateAreas?.map?.((item) => `"${item}"`)?.join?.(' ') || '';
            return parseStyle(styleObj);
        }
    },
    methods: {
        gridCellStyle(item) {
            return {
                gridArea: item.props.gridArea || '',
            };
        }
    }
};
</script>

<style lang="less" scoped>
.grid-container {
    position: relative;
    display: grid;
    height: auto !important;
    width: auto !important;
    overflow: visible;
    gap: 0px 0px;

    .grid-cell {
        >div {
            width: 100% !important;
            height: 100% !important;
        }
    }
}
</style>
